"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KEY_SPACE = exports.KEY_ENTER = void 0;
var KEY_ENTER = "Enter";
exports.KEY_ENTER = KEY_ENTER;
var KEY_SPACE = " ";
exports.KEY_SPACE = KEY_SPACE;